module.exports = __webpack_public_path__ + "static/media/women.e7e1936b.svg";